<template>
    <div class="pointtext">
        <span v-bind:class="type">{{ text }}</span>
    </div>
</template>
  
<script>
export default {
    props: {
        text: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: "default"
        }
    },
    data() {
        return {
            url: '/static/icon/point.png'
        }
    },
    name: 'pointtext',
}

</script>

<style scoped>
.pointtext span {
    color: #858b9c;
}
.pointtext .default::before {
    content: '';
    display: inline-block;
    background: url('/static/icon/point_default.png');
    background-size: cover;
    width:0.5rem;
    height:0.36rem;
}
.pointtext .success::before {
    content: '';
    display: inline-block;
    background: url('/static/icon/point_success.png');
    background-size: cover;
    width:0.5rem;
    height:0.36rem;
}   
.pointtext .fail::before {
    content: '';
    display: inline-block;
    background: url('/static/icon/point_fail.png');
    background-size: cover;
    width:0.5rem;
    height:0.36rem;
}

.pointtext .notline::before {
    content: '';
    display: inline-block;
    background: url('/static/icon/point_notline.png');
    background-size: cover;
    width:0.5rem;
    height:0.36rem;
}

.pointtext .line-purple::before {
    content: '';
    display: inline-block;
    background: url('/static/icon/line_purple.png');
    background-size: cover;
    width:0.5rem;
    height:0.36rem;
}

.pointtext .line-success::before {
    content: '';
    display: inline-block;
    background: url('/static/icon/line_success.png');
    background-size: cover;
    width:0.5rem;
    height:0.36rem;
}

.pointtext .batch::before {
    content: '';
    display: inline-block;
    background: url('/static/icon/batch.png');
    background-size: cover;
    width:0.5rem;
    height:0.36rem;
}
.pointtext .delimiter_line::before {
    content: '';
    display: inline-block;
    background: url('/static/icon/delimiter_line.png');
    background-size: cover;
    width:0.5rem;
    height:0.36rem;
}

.pointtext .kyc::before {
    content: '';
    display: inline-block;
    background: url(/static/icon/kyc.png);
    background-size: cover;
    width: 0.34rem;
    height: 0.34rem;
    position: relative;
    top: 3px;
    margin-right: 5px;
}

.pointtext .add::before {
    content: '';
    display: inline-block;
    background: url(/static/icon/add.png);
    background-size: cover;
    width: 0.34rem;
    height: 0.34rem;
    position: relative;
    top: 3px;
    margin-right: 5px;
}

.pointtext .gift::before {
    content: '';
    display: inline-block;
    background: url(/static/icon/gift.png);
    background-size: cover;
    width: 0.34rem;
    height: 0.34rem;
    position: relative;
    top: 3px;
    margin-right: 5px;
}

.pointtext .i::before {
    content: '';
    display: inline-block;
    background: url(/static/icon/i.png);
    background-size: cover;
    width: 0.34rem;
    height: 0.34rem;
    position: relative;
    top: 3px;
    margin-right: 5px;
}

.pointtext .paying::before {
    content: '';
    display: inline-block;
    background: url(/static/icon/paying.png);
    background-size: cover;
    width: 0.34rem;
    height: 0.34rem;
    position: relative;
    top: 3px;
    margin-right: 5px;
}



</style>



// WEBPACK FOOTER //
// src/components/pointtext.vue